import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { useAccessTheme } from '../useAccessTheme';

interface IdentityProviderModalShellProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  maxWidthClass?: string;
}

const IdentityProviderModalShell: React.FC<IdentityProviderModalShellProps> = ({
  title,
  subtitle,
  icon,
  onClose,
  children,
  footer,
  maxWidthClass = 'max-w-lg',
}) => {
  const t = useAccessTheme();

  return createPortal(
    <div
      className={'fixed inset-0 flex items-center justify-center p-4 ' + t.overlay}
      style={{ zIndex: 200 }}
    >
      <div className={`rounded-xl shadow-xl w-full ${maxWidthClass} overflow-hidden border ${t.panel}`}>
        <div className={'flex items-center justify-between px-5 py-4 border-b ' + t.header}>
          <div className="flex items-center gap-3 min-w-0">
            {icon ? (
              <div className={'w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ' + t.iconBg}>
                {icon}
              </div>
            ) : null}
            <div className="min-w-0">
              <h3 className={'text-lg font-semibold ' + t.title}>{title}</h3>
              {subtitle ? <p className={'text-xs mt-0.5 ' + t.muted}>{subtitle}</p> : null}
            </div>
          </div>
          <button type="button" onClick={onClose} className={'p-2 rounded-lg shrink-0 ' + t.closeBtn}>
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-5 space-y-4 max-h-[70vh] overflow-y-auto">{children}</div>

        {footer ? (
          <div className={'px-5 py-4 border-t flex justify-end gap-2 ' + t.footer}>{footer}</div>
        ) : null}
      </div>
    </div>,
    document.body
  );
};

export default IdentityProviderModalShell;
